<script setup>

import {inject} from 'vue'
import axios from "axios";
import Notification from "@/classes/component-classes/Notification";
import DocumentDownloadLayout from "@/components/common/other/DocumentDownloadLayout.vue";

import {useStore} from 'vuex';
import {useDownloadLocalFile} from "@/composables/common/useDownloadLocalFile";

const store = useStore();

// const shipments = inject("shipments");

const props = defineProps({

  modelValue: {},
  url: ''
})

function downloadDocument(doc) {

  doc.isDownloading = true;

  axios.get(props.url, {

    responseType:'blob',
    params: {
      owner: store.state.owner,
      id: doc.id
    }

  }).then((response) => {

    if(response) {

      useDownloadLocalFile(response);
      doc.downloaded = true;
      doc.isDownloading = false;
    }

  }).catch(function (error) {

    store.state.banners.error = new Notification(true, 'Could Not Perform Download');
    doc.isDownloading = false;

  });
}

</script>

<template>
  <DocumentDownloadLayout
      @download-document="downloadDocument"
      v-model="modelValue.shipmentDocs">
  </DocumentDownloadLayout>
</template>

<style lang="scss" scoped>

</style>
